"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Link: true
};
exports.default = exports.Link = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _isReactFragment = require("../utils/isReactFragment");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ToolbarOverflowLayout = require("../Toolbar/_ToolbarOverflowLayout");
var _Link = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Link.css") : void 0);
var _Link2 = require("./Link.types");
Object.keys(_Link2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Link2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Link2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-link';
/**
 * **Link** components are used to navigate to another page, another
 * section within a page or an external website.
 *
 * > Links and buttons are sometimes used interchangeably, but from an accessibility perspective,
 * > there are specific use cases for each. Please see
 * > [Design Usage for Link Button and Link](./?path=/docs/design-buttons--docs)
 * > for the distinction between the two and proper usage.
 */
const Link = exports.Link = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Link, _props)) : _props;
  const {
      children,
      className,
      disabled,
      href,
      innerTextClasses,
      matchButtonHeight,
      muted,
      onClick,
      inToolbarOverflow,
      toolbarLayoutProps
    } = props,
    otherProps = __rest(props, ["children", "className", "disabled", "href", "innerTextClasses", "matchButtonHeight", "muted", "onClick", "inToolbarOverflow", "toolbarLayoutProps"]);
  const classnames = _bind.default.bind(_Link.default);
  const isNonActionableHref = () => !href || href.trim() === '#';
  const handleClick = event => {
    if (disabled || isNonActionableHref()) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--muted`]: muted,
    [`${CSS_BLOCK}--disabled`]: disabled,
    [`${CSS_BLOCK}--button-height`]: matchButtonHeight
  });
  const passChildProps = (child, childProps) => {
    const {
      className: childClassName,
      forceSize
    } = childProps;
    if (child.displayName === 'Badge') {
      return {
        className: classnames(`${CSS_BLOCK}__badge`, childClassName)
      };
    }
    if (child.displayName === 'Icon') {
      return {
        className: classnames(`${CSS_BLOCK}__icon`, childClassName),
        size: forceSize || 'sm'
      };
    }
    return null;
  };
  const renderChildren = childNodes => {
    let textNodeSegment = [];
    const innerTextClassName = classnames(innerTextClasses, `${CSS_BLOCK}__text`);
    let startIconOrBadge;
    let centerText;
    let endIconOrBadge;
    const alteredChildren = _react.default.Children.map(childNodes, child => {
      var _a;
      if (child === null) return null;
      if ((0, _isReactFragment.isReactFragment)(child)) {
        return renderChildren(child.props.children);
      }
      const compName = (_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName;
      const isIconOrBadge = compName === 'Icon' || compName === 'Badge';
      const isTextNodeSegment = ! /*#__PURE__*/_react.default.isValidElement(child) || compName !== 'Icon' && compName !== 'Badge';
      if (isIconOrBadge) {
        if (!startIconOrBadge && !centerText) {
          startIconOrBadge = child;
        } else {
          endIconOrBadge = child;
        }
      } else if (isTextNodeSegment) {
        centerText = child;
      }
      if (isTextNodeSegment) {
        textNodeSegment.push(child);
      } else {
        if (textNodeSegment.length) {
          const textChild = textNodeSegment;
          textNodeSegment = [];
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            className: innerTextClassName
          }, textChild), child);
        }
        return child;
      }
      return null;
    });
    if (inToolbarOverflow) {
      return /*#__PURE__*/_react.default.createElement(_ToolbarOverflowLayout.ToolbarOverflowLayout, Object.assign({
        startIconOrBadge: startIconOrBadge,
        innerTextClassName: innerTextClassName,
        centerText: centerText,
        endIconOrBadge: endIconOrBadge
      }, toolbarLayoutProps));
    }
    if (textNodeSegment.length) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, alteredChildren, /*#__PURE__*/_react.default.createElement("span", {
        className: innerTextClassName
      }, textNodeSegment));
    }
    return alteredChildren;
  };
  return /*#__PURE__*/_react.default.createElement("a", Object.assign({}, otherProps, {
    "aria-disabled": disabled,
    className: classes,
    href: !disabled ? href : undefined,
    onClick: handleClick,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, renderChildren(children)));
});
Link.displayName = 'Link';
var _default = exports.default = Link;